export default "__VITE_ASSET__DnSf7TSs__"